import { createContext } from "react";

export const Context = createContext();
export const TimeContext = createContext();
